import { Form } from "react-bootstrap";

export default function CategoriaNoticia({
  caractFiltro,
  handleChange,
  nameCombo,
  idCategoria,
}) {
  return (
    <Form.Select
      className="inputs-forms-admin focus-admin-register"
      onChange={handleChange}
      name={nameCombo}
      value={idCategoria}
    >
      <option key={'-1'} value={''}>Seleccione...</option>
      {caractFiltro.resultCategoriasNoticias.map((e, i) => {
        if (e.nombre !== 'Portada') {
          return (
              <option key={e.id_categoria} value={e.id_categoria}>
                {e.nombre}
              </option>
          );
        }
      })}
    </Form.Select>
  );
}
